module.exports = __webpack_public_path__ + "media/img/super-venue/benefits1-99e247979f669d94c544ad432a8a2b9d.png";